// export default CollectionReport;
// import React, { useState, useEffect } from "react";
// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";
// import axios from "axios";
// import "./CollectionReportTest.css";

// const API_URL = "https://payyug.in/api/loan-emi/";

// const CollectionReportTest = () => {
//   const [collections, setCollections] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   // 🔹 Fetch data from API
//   useEffect(() => {
//       const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

//     const fetchCollections = async () => {
//       try {
//         setLoading(true);
//         const res = await axios.get(`${API_URL}collection-sheet?superAdminId=${superAdminId}`);
//         if (res.data && res.data.collections) {
//           setCollections(res.data.collections);
//         }
//       } catch (error) {
//         console.error("Error fetching collection report:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCollections();
//   }, []);

//   // 🔹 Pagination
//   const totalPages = Math.ceil(collections.length / rowsPerPage);
//   const startIndex = (currentPage - 1) * rowsPerPage;
//   const currentData = collections.slice(startIndex, startIndex + rowsPerPage);

//   const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
//   const handleNext = () => currentPage < totalPages && setCurrentPage(currentPage + 1);

//   // // 🔹 PDF Export
//   // const handleDownloadPDF = () => {
//   //   const doc = new jsPDF();
//   //   doc.setFontSize(18);
//   //   doc.text("Company Collection Report", 14, 20);

//   //   const tableColumn = [
//   //     "#",
//   //     "Customer Name",
//   //     "Loan Number",
//   //     "EMI Number",
//   //     "EMI Amount",
//   //     "Principal",
//   //     "Interest",
//   //     "Outstanding",
//   //     "Due Date",
//   //     "Payment Date",
//   //     "Status",
//   //   ];

//   //   const tableRows = currentData.map((c, index) => [
//   //     startIndex + index + 1,
//   //     c.customerName,
//   //     c.loanNumber,
//   //     c.emiNumber,
//   //     `₹${c.emiAmount.toLocaleString()}`,
//   //     `₹${c.principalComponent.toLocaleString()}`,
//   //     `₹${c.interestComponent.toLocaleString()}`,
//   //     `₹${c.outstanding.toLocaleString()}`,
//   //     new Date(c.dueDate).toLocaleDateString("en-IN"),
//   //     c.paymentDate ? new Date(c.paymentDate).toLocaleDateString("en-IN") : "-",
//   //     c.status,
//   //   ]);

//   //   autoTable(doc,{
//   //     startY: 30,
//   //     head: [tableColumn],
//   //     body: tableRows,
//   //     theme: "grid",
//   //     headStyles: { fillColor: [99, 102, 241], textColor: 255 },
//   //     styles: { fontSize: 10, cellPadding: 3 },
//   //   });

//   //   doc.save("Collection_Report.pdf");
//   // };

//   // 🔹 PDF Export (Professional Black & White Design)
// const handleDownloadPDF = () => {
//   const doc = new jsPDF();
//   doc.setFontSize(16);
//   doc.setFont("helvetica", "bold");
//   doc.text("📋 Company Collection Report", 14, 18);

//   const tableColumn = [
//     "#",
//     "Customer Name",
//     "Loan Number",
//     "EMI Number",
//     "EMI Amount",
//     "Principal",
//     "Interest",
//     "Outstanding",
//     "Due Date",
//     "Payment Date",
//     "Status",
//   ];

//   const tableRows = currentData.map((c, index) => [
//     startIndex + index + 1,
//     c.customerName,
//     c.loanNumber,
//     c.emiNumber,
//     `₹${c.emiAmount.toLocaleString()}`,
//     `₹${c.principalComponent.toLocaleString()}`,
//     `₹${c.interestComponent.toLocaleString()}`,
//     `₹${c.outstanding.toLocaleString()}`,
//     new Date(c.dueDate).toLocaleDateString("en-IN"),
//     c.paymentDate ? new Date(c.paymentDate).toLocaleDateString("en-IN") : "-",
//     c.status.toUpperCase(),
//   ]);

//   autoTable(doc, {
//     startY: 28,
//     head: [tableColumn],
//     body: tableRows,
//     theme: "grid",
//     headStyles: {
//       fillColor: [0, 0, 0], // Black header
//       textColor: [255, 255, 255], // White text
//       fontStyle: "bold",
//     },
//     styles: {
//       font: "helvetica",
//       fontSize: 9,
//       cellPadding: 3,
//       lineColor: [0, 0, 0], // Black borders
//       lineWidth: 0.1,
//       textColor: [0, 0, 0],
//     },
//     alternateRowStyles: {
//       fillColor: [240, 240, 240], // Light grey rows
//     },
//     bodyStyles: {
//       textColor: [0, 0, 0],
//     },
//   });

//   // Footer
//   const pageCount = doc.internal.getNumberOfPages();
//   for (let i = 1; i <= pageCount; i++) {
//     doc.setPage(i);
//     doc.setFontSize(8);
//     doc.setTextColor(100);
//     doc.text(
//       `Page ${i} of ${pageCount}`,
//       doc.internal.pageSize.getWidth() - 30,
//       doc.internal.pageSize.getHeight() - 10
//     );
//     doc.text("Generated by Collection System", 14, doc.internal.pageSize.getHeight() - 10);
//   }

//   doc.save("Collection_Report.pdf");
// };

//   return (
//     <div className="collection-report-container">
//       <h1 className="collection-report-title">📋 Collection Report</h1>

//       {/* Controls */}
//       <div className="collection-report-controls">
//         <label>
//           Show{" "}
//           <select
//             value={rowsPerPage}
//             onChange={(e) => {
//               setRowsPerPage(Number(e.target.value));
//               setCurrentPage(1);
//             }}
//           >
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//             <option value={50}>50</option>
//           </select>{" "}
//           entries
//         </label>

//         <button className="collection-report-filter-btn" onClick={handleDownloadPDF}>
//           📄 Download PDF
//         </button>
//       </div>

//       {/* Table */}
//       <div className="collection-report-table-container">
//         {loading ? (
//           <p className="collection-report-loading">⏳ Loading data...</p>
//         ) : (
//           <table className="collection-report-table">
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Customer Name</th>
//                 <th>Loan Number</th>
//                 <th>EMI Number</th>
//                 <th>EMI Amount</th>
//                 <th>Principal</th>
//                 <th>Interest</th>
//                 <th>Outstanding</th>
//                 <th>Due Date</th>
//                 <th>Payment Date</th>
//                 <th>Status</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentData.length === 0 ? (
//                 <tr>
//                   <td colSpan="11" className="collection-report-empty">
//                     ✅ No records found
//                   </td>
//                 </tr>
//               ) : (
//                 currentData.map((c, idx) => (
//                   <tr key={c.id}>
//                     <td>{startIndex + idx + 1}</td>
//                     <td>{c.customerName}</td>
//                     <td>{c.loanNumber}</td>
//                     <td>{c.emiNumber}</td>
//                     <td>₹{c.emiAmount.toLocaleString()}</td>
//                     <td>₹{c.principalComponent.toLocaleString()}</td>
//                     <td>₹{c.interestComponent.toLocaleString()}</td>
//                     <td>₹{c.outstanding.toLocaleString()}</td>
//                     <td>{new Date(c.dueDate).toLocaleDateString("en-IN")}</td>
//                     <td>{c.paymentDate ? new Date(c.paymentDate).toLocaleDateString("en-IN") : "-"}</td>
//                     <td>
//                       <span className={`collection-report-status ${c.status === "pending" ? "pending" : "paid"}`}>
//                         {c.status}
//                       </span>
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         )}
//       </div>

//       {/* Pagination */}
//       {!loading && (
//         <div className="collection-report-pagination">
//           <button className="collection-report-pagination-btn" onClick={handlePrev} disabled={currentPage === 1}>
//             ⬅ Prev
//           </button>
//           <span className="collection-report-pagination-info">
//             Page {currentPage} of {totalPages}
//           </span>
//           <button className="collection-report-pagination-btn" onClick={handleNext} disabled={currentPage === totalPages}>
//             Next ➡
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CollectionReportTest;



import React, { useState, useEffect } from "react";
import { jsPDF } from "jspdf";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx-js-style";
import autoTable from "jspdf-autotable";
import axios from "axios";
import "./CollectionReportTest.css";
import { toast } from "react-toastify";
import { ArrowLeftIcon, ArrowRightIcon, Download, FileTextIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";

//const API_URLI = "https://payyug.in/api/loan-emi/";
const API_URL = "https://payyug.in/api";

const CollectionReportTest = () => {
  const navigate=useNavigate();
   const { list:employeeReport } = useSelector((state) => state.employeeReport);
      const dispatch=useDispatch()
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState();
    const [statusFilter, setStatusFilter] = useState("all");

  const [company, setCompany] = useState(null);
  const [centers, setCenters] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [branchs, setBranchs] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [loanType, setLoanType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");


  // Verify payment
    const [verifyModalOpen, setVerifyModalOpen] = useState(false);
    const [selectedCollection, setSelectedCollection] = useState(null);
    const [verifying, setVerifying] = useState(false);
    const [paymentMode, setPaymentMode] = useState("CASH");
    const [paymentRemark, setPaymentRemark] = useState("");
    const [paymentDate, setPaymentDate] = useState(
      new Date().toISOString().split("T")[0],
    );

  const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

     useEffect(() => {
        dispatch(fetchEmployeeReport({ page: currentPage, superAdminId,branch:selectedBranch?.id }));
      }, [dispatch, currentPage,selectedBranch?.id, superAdminId]);
  
        const employeesList = employeeReport?.data || employeeReport || [];

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${superAdminId}`,
        );
        const data = await response.json();

        if (response.ok && data) {
          // Dynamically construct logo URL
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
          }
          setCompany(data);
        } else {
          console.error("Failed to fetch company data");
        }
      } catch (err) {
        console.error("Error fetching company details:", err);
      } finally {
        setLoading(false);
      }
    };

    if (superAdminId) fetchCompany();
  }, [superAdminId]);

  const fetchCollections = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `https://payyug.in/api/group-loan/emi/collection-report`,
        {
          params: {
            superAdminId,
            centerId:
              selectedCenter?.id === "all" ? "" : selectedCenter?.id || "",
            branchId: selectedBranch?.id || "",
            createdBy:selectedEmployee?.id,
            groupId: selectedGroup?.id === "all" ? "" : selectedGroup?.id || "",
            loanType: loanType,
            fromDate: fromDate || undefined,
            toDate: toDate || undefined,
            page: currentPage,
            limit: rowsPerPage==="All"?100000:rowsPerPage,
          },
        },
      );
      if (res.data && res.data.data) {
        setCollections(res.data.data);
      }
      setTotalPages(res.data.pagination.totalPages);
    } catch (error) {
      console.error("Error fetching collection report:", error);
    } finally {
      setLoading(false);
    }
  };

  /* ================= FETCH Branch ================= */
  useEffect(() => {
    const fetchBranch = async () => {
      try {
        const res = await axios.get(`${API_URL}/get-branch`, {
          params: {
            SuperAdminId: localStorage.getItem("adminuserId"),
            limit: "all",
          },
        });
        // console.log("branch data", res.data);
        setBranchs(res?.data.branches);
      } catch (err) {
        console.error(err);
      }
    };

    fetchBranch();
  }, []);

  /* ================= FETCH CENTERS ================= */
  useEffect(() => {
    // if (!selectedBranch?.id) return;
    const fetchCenters = async () => {
      try {
        const superAdminId = localStorage.getItem("adminuserId");
        if (!superAdminId) return;

        const res = await axios.get(`${API_URL}/group/centre`, {
          params: {
            superAdminId,
            branchid: selectedBranch?.id,
            limit: 100000,
          },
        });

        // console.log("center list", res.data?.data);

        setCenters(res.data?.data || []);
      } catch (err) {
        console.error(err);
      }
    };
    fetchCenters();
  }, [selectedBranch]);

  /* ================= FETCH GROUPS ================= */
  useEffect(() => {
    if (!selectedBranch?.id || !selectedCenter) return;

    const fetchGroups = async () => {
      try {
        const superAdminId = localStorage.getItem("adminuserId");

        const res = await axios.get(`${API_URL}/groupupdate/getall`, {
          params: {
            superAdminId,
            CenterId:
              selectedCenter.id === "all" ? "" : selectedCenter.id || "",
            limit: 100000,
          },
        });
        setGroups(res.data?.data || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchGroups();
  }, [selectedCenter, selectedBranch]);


    const filteredCollections = collections.filter((c) => {
      const matchesStatus =
        statusFilter === "all" ||
        c.status?.toLowerCase() === statusFilter.toLowerCase();
  
      return matchesStatus;
    });
  
    useEffect(() => {
      setCurrentPage(1);
    }, [statusFilter]);


    const handleOpenVerifyModal = (item) => {
    setSelectedCollection(item);
    setPaymentMode("CASH");
    setPaymentDate(new Date().toISOString().split("T")[0]);
    setVerifyModalOpen(true);
  };

  // API handler matching your payload structure
  const handleConfirmVerify = async () => {
    if (!selectedCollection) return;

    if (!paymentDate) {
      alert("Please select a payment date.");
      return;
    }

    try {
      setVerifying(true);
      const res = await axios.post(
        `${API_URL}/group-loan/emi/pay`,
        {
          emiId: selectedCollection.id,
          superAdminId,
          paidAmount: selectedCollection?.emiAmount,
          paymentMode,
          paidDate:paymentDate,
          remark:paymentRemark||"",
        },
      );

      if (res.data?.success || res.status === 200) {
        toast.success(res?.data?.message||"Payment verified.")
        setCollections((prev) =>
          prev.map((c) =>
            c.id === selectedCollection.id
              ? {
                  ...c,
                  status: "paid",
                  paymentDate: new Date(paymentDate).toISOString(),
                }
              : c,
          ),
        );
        setVerifyModalOpen(false);
        setSelectedCollection(null);
      }
    } catch (error) {
      console.error("Error verifying collection:", error);
      alert(error?.response?.data?.message || "Failed to verify collection.");
    } finally {
      setVerifying(false);
    }
  };

  // 🔹 Pagination
  // const totalPages = Math.ceil(collections.length / rowsPerPage);
  const startIndex =(currentPage - 1) * rowsPerPage;

  const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
  const handleNext = () =>
    currentPage < totalPages && setCurrentPage(currentPage + 1);

  const exportExcel = () => {
    const data = filteredCollections.map((item) => ({
      State: item.member?.state || "N/A",
      Region: selectedBranch?.name || "N/A",
      Branch: selectedBranch?.name || "N/A",
      "Loan Officer Name": item.loanAccount?.officerName || "N/A",
      "Account No": item.loanAccount?.loanAccountNumber || "N/A",
      "Loan Type": item.loanAccount?.loanType || "N/A",
      "Loan Amount": item.loanAccount?.loanAmount
        ? item.loanAccount?.loanAmount
        : 0,
      "Center Name": item.loanAccount?.centerName || "N/A",
      "Group Name": item.loanAccount?.groupName || "N/A",
      "Member Name": item.loanAccount?.memberName || "N/A",
      "Guardian Name": item.member?.guardianName || "N/A",
      "Mobile No.": item.member?.mobileNumber || "N/A",
      "Emi Amount": item.emiAmount ? item.emiAmount : 0,
      "Paid Amount": item.paidAmount ? item.paidAmount : 0,
      "Outstanding amount": item.outstanding ? item.outstanding : 0,
      "Paid Date": item.paidDate
        ? new Date(item.paidDate).toLocaleDateString("en-GB")
        : "N/A",
      Status: item.status || "N/A",
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);

    // 🔹 Header styling
    const headerCells = Object.keys(data[0]);
    headerCells.forEach((_, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
      worksheet[cellRef].s = {
        font: {
          bold: true,
          color: { rgb: "FFFFFF" },
        },
        fill: {
          fgColor: { rgb: "1F4E78" }, // dark blue
        },
        alignment: {
          horizontal: "center",
          vertical: "center",
        },
      };
    });

    // 🔹 Auto column width
    worksheet["!cols"] = headerCells.map((key) => ({
      wch: Math.max(key.length + 5, 18),
    }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Loan Report");

    XLSX.writeFile(workbook, "Group_Collection_Report.xlsx");
  };

  // 🔹 PDF Export (Professional Black & White Design)
  const handleDownloadPDF = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    // ================= LOGO =================
    const logoX = 15;
    const logoY = 12;
    const logoSize = 25;
    const logoPadding = 2;

    // Border color & thickness
    doc.setDrawColor(0);
    doc.setLineWidth(0.2);

    // Calculate center of logo
    const centerX = logoX + logoSize / 2;
    const centerY = logoY + logoSize / 2;

    // Radius = half of logo + padding
    const radius = logoSize / 2 + logoPadding;

    // Draw circle
    doc.circle(centerX, centerY, radius);

    // Logo image
    if (company?.logoUrl) {
      try {
        const logoResp = await fetch(company.logoUrl);
        const logoBlob = await logoResp.blob();
        const reader = new FileReader();
        await new Promise((resolve) => {
          reader.onload = () => {
            doc.addImage(
              reader.result,
              "PNG",
              logoX,
              logoY,
              logoSize,
              logoSize,
            );
            resolve();
          };
          reader.readAsDataURL(logoBlob);
        });
      } catch {
        // silent fail
      }
    }

    // ================= COMPANY NAME (AUTO WRAP) =================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);

    const nameX = logoX + logoSize + 5;
    const nameY = 18;
    const nameMaxWidth = pageWidth - nameX - 15;

    const companyNameText = doc.splitTextToSize(
      (company?.name || "COMPANY NAME").toUpperCase(),
      nameMaxWidth,
    );

    doc.text(companyNameText, nameX, nameY);

    // Calculate Y after company name
    let currentY = nameY + companyNameText.length * 6;

    // ================= COMPANY DETAILS =================
    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);

    const detailX = nameX;
    const detailMaxWidth = nameMaxWidth;

    // Address
    const addressText = doc.splitTextToSize(
      company?.address || "Company Address",
      detailMaxWidth,
    );
    doc.text(addressText, detailX, currentY);
    currentY += addressText.length * 5;

    // Email
    const emailText = doc.splitTextToSize(
      `Email: ${company?.email || "-"}`,
      detailMaxWidth,
    );
    doc.text(emailText, detailX, currentY);
    currentY += emailText.length * 5;

    // Phone
    const phoneText = doc.splitTextToSize(
      `Phone: ${company?.contact || "-"}`,
      detailMaxWidth,
    );
    doc.text(phoneText, detailX, currentY);
    currentY += phoneText.length * 5;

    // Divider
    doc.line(10, currentY + 4, pageWidth - 10, currentY + 4);

    // ================= REPORT TITLE =================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    doc.text("Group Collection Report", pageWidth / 2, currentY + 14, {
      align: "center",
    });

     const tableColumn = [
      "SN",
      "Account No",
      "Loan Type",
      "Loan Amount",
      "Center",
      "Group",
      "Member",
      "Mobile",
      "Emi Amount",
      "Paid Amount",
      "Paid Date",
      "Status",
    ];

    const tableRows = filteredCollections.map((item, index) => [
      startIndex + index + 1,
       item.loanAccount?.loanAccountNumber || "N/A",
        item.loanAccount?.loanType || "N/A",
        item.loanAccount?.loanAmount ? item.loanAccount?.loanAmount : 0,
        item.loanAccount?.centerName || "N/A",
        item.loanAccount?.groupName || "N/A",
        item.loanAccount?.memberName || "N/A",
        item.member?.mobileNumber || "N/A",
        item.emiAmount ? item.emiAmount : 0,
        item.paidAmount ? item.paidAmount : 0,
        item.paidDate ? new Date(item.paidDate).toLocaleDateString("en-GB") : "N/A",
        item.status || "N/A",
    ]);

    autoTable(doc, {
      startY: currentY + 20,
      head: [tableColumn],
      body: tableRows,

      theme: "grid",
      styles: {
        fontSize: 7,
        cellPadding: 3,
        halign: "center",
      },
      headStyles: {
        fontStyle: "bold",
        fontSize: 7,
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },

      didDrawPage: function () {
        const pageWidth = doc.internal.pageSize.width;
        const pageHeight = doc.internal.pageSize.height;

        doc.setDrawColor(0);
        doc.setLineWidth(0.2);

        // Page border on EVERY page
        doc.rect(8, 8, pageWidth - 16, pageHeight - 16);
      },
    });

    // ================= FOOTER =================
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(100);
      doc.text(`Page ${i} of ${pageCount}`, pageWidth - 30, pageHeight - 10);
      doc.text("Generated by Collection System", 14, pageHeight - 10);
    }

    doc.save("Group_Collection_Report.pdf");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedCenter) {
      toast.error("Please select a Center before filtering.");
      return;
    }

    setCurrentPage(1);
    await fetchCollections();
    toast.success("EMI report filtered successfully!");
  };

useEffect(() => {
  if (!selectedCenter) return;
  fetchCollections();
}, [currentPage, rowsPerPage]);

  return (
    <div className="collection-report-container">
      {/* Back wrapper */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "8px 16px",
          backgroundColor: "#fff",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          marginBottom: "20px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
        }}
      >
        <ArrowLeftIcon
          onClick={() => navigate(-1)}
          style={{
            cursor: "pointer",
            padding: "4px",
            borderRadius: "4px",
            transition: "background-color 0.2s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#f5f5f5")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
        />

        <h2
          style={{
            margin: 0,
            fontSize: "18px",
            fontWeight: "600",
            color: "#333",
          }}
        >
          Group Loan Collection Report
        </h2>

        <ArrowRightIcon
          onClick={() => navigate(1)}
          style={{
            cursor: "pointer",
            padding: "4px",
            borderRadius: "4px",
            transition: "background-color 0.2s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#f5f5f5")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
        />
      </div>

      <section className="pending-disbursal-filter-section">
        {/* <h2 className="pending-disbursal-title">Collection Report Filter</h2>
        <p className="pending-disbursal-sub-title">
          Use filters to refine Emi due report
        </p> */}
        <form className="pending-disbursal-form" onSubmit={handleSubmit}>
          <div className="pending-disbursal-grid">
            {/* Branch */}
            <div className="pending-disbursal-form-group">
              <label>Select Branch</label>
              <select
                value={selectedBranch?.id || ""}
                onChange={(e) => {
                  const branch = branchs.find(
                    (br) => br.id === Number(e.target.value),
                  );
                  setSelectedBranch(branch);
                  setSelectedCenter(null); // reset
                  setSelectedGroup(null); // reset
                }}
              >
                <option value="">Select Branch</option>
                {branchs.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Employee */}
            <div className="pending-disbursal-form-group">
              <label>Select Employee</label>
              <select
                value={selectedEmployee?.id || ""}
                disabled={!selectedBranch}
                onChange={(e) => {
                  const val = e.target.value;
                    const employee = employeesList.find((em) => em.id === Number(val));
                    setSelectedEmployee(employee || null);
                }}
              >
                <option value="">Select Employee</option>
                {employeesList.map((e) => (
                  <option key={e.id} value={e.id}>
                    {e.fullName}
                  </option>
                ))}
              </select>
            </div>

            {/* Center */}
            <div className="pending-disbursal-form-group">
              <label>Select Center</label>
              <select
                value={selectedCenter?.id || ""}
                disabled={!selectedBranch}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === "all") {
                    setSelectedCenter({ id: "all", CenterName: "All" });
                  } else {
                    const center = centers.find((cn) => cn.id === Number(val));
                    setSelectedCenter(center);
                  }
                  setSelectedGroup(null); // reset
                }}
              >
                <option value="">Select Center</option>
                <option value="all">All Centers</option>
                {centers.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.CenterName}
                  </option>
                ))}
              </select>
            </div>

            {/* Group */}
            <div className="pending-disbursal-form-group">
              <label>Select Group</label>
              <select
                value={selectedGroup?.id || ""}
                disabled={!selectedBranch || !selectedCenter}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === "all") {
                    setSelectedGroup({ id: "all", groupname: "All" });
                  } else {
                    const group = groups.find((gr) => gr.id === Number(val));
                    setSelectedGroup(group);
                  }
                }}
              >
                <option value="">Select Group</option>
                <option value="all">All Groups</option>
                {groups.map((g) => (
                  <option key={g.id} value={g.id}>
                    {g.groupname}
                  </option>
                ))}
              </select>
            </div>

            {/* Loan Type ← ADDED */}
            <div className="pending-disbursal-form-group">
              <label>Loan Type</label>
              <select
                value={loanType}
                onChange={(e) => {
                  const val = e.target.value;
                  setLoanType(val);
                }}
              >
                <option value="">All Loan Types</option>
                <option value="FIXED">Fixed</option>
                <option value="INDIVIDUAL">Individual</option>
              </select>
            </div>
            <div className="pending-disbursal-form-group">
              <label>From Date</label>
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>
            <div className="pending-disbursal-form-group">
              <label>To Date</label>
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>
            <div className="pending-disbursal-form-group">
              <label>Status</label>
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="CollectionReport-search"
          >
            <option value="all">All Statuses</option>
            <option value="PAID">Paid</option>
            <option value="REQUESTED">Requested</option>
          </select>
            </div>
          </div>
          <div className="filterbtnpdt">
            <button type="submit" className="pending-disbursal-submit-btn">
              Apply Filter
            </button>
          </div>
        </form>
      </section>

      {/* Controls */}
      <div className="collection-report-controls">
        <label>
          Show{" "}
          <select
            value={rowsPerPage}
            onChange={(e) => {
              const value=e.target.value
              setRowsPerPage(value==="All"?"All":Number(value));
              setCurrentPage(1);
            }}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={"All"}>All</option>
          </select>{" "}
          entries
        </label>

        {filteredCollections.length > 0 && (
          <div className="" style={{display:"flex",gap:"5px",marginTop:"10px"}}>
            <button
              className="collection-report-filter-btn"
              style={{display:"flex",alignItems:"center",gap:"5px"}}
              onClick={exportExcel}
            >
              <FileTextIcon size={18} /> Excel
            </button>
            <button
              className="collection-report-filter-btn"
              style={{display:"flex",alignItems:"center",gap:"5px"}}
              onClick={handleDownloadPDF}
            >
              <Download size={18} /> PDF
            </button>
          </div>
        )}
      </div>

      {/* Table */}
      <div className="collection-report-table-container">
        {loading ? (
          <p className="collection-report-loading">⏳ Loading data...</p>
        ) : (
          <table className="collection-report-table">
            <thead>
              <tr>
                <th>#</th>
              <th>Loan Account No</th>
              <th>Loan Type</th>
              <th>Loan Amount</th>
              <th>Center Name</th>
              <th>Group Name</th>
              <th>Member Name</th>
              <th>Mobile No</th>
              <th>EMI Amount</th>
              <th>Paid Amount</th>
              <th>Outstanding</th>
              <th>Paid Date</th>
              <th>Status</th>
              <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredCollections.length === 0 ? (
                <tr>
                  <td colSpan="11" className="collection-report-empty">
                    ✅ No records found
                  </td>
                </tr>
              ) : (
                filteredCollections.map((c, idx) => (
                  <tr key={c.id}>
                    <td>{rowsPerPage==="All"?idx+1:startIndex + idx + 1}</td>
                    <td>{c.loanAccount?.loanAccountNumber || "N/A"}</td>
                    <td>{c.loanAccount?.loanType || "N/A"}</td>
                    <td>{c.loanAccount?.loanAmount}</td>
                    <td>{c.loanAccount?.centerName || "N/A"}</td>
                    <td>{c.loanAccount?.groupName || "N/A"}</td>
                    <td>{c.loanAccount?.memberName || "N/A"}</td>
                    <td>{c.member?.mobileNumber || "N/A"}</td>
                    <td>₹{`${c.emiAmount ? c.emiAmount : 0}`}</td>
                    <td>₹{`${c.paidAmount ? c.paidAmount : 0}`}</td>
                    <td>₹{`${c.outstanding ? c.outstanding : 0}`}</td>
                    <td>
                      {c.paidDate
                        ? new Date(c.paidDate).toLocaleDateString("en-GB")
                        : "-"}
                    </td>
                    <td>
                      <span
                        className={`collection-report-status ${c.status === "pending" ? "pending" : "paid"}`}
                      >
                        {c.status}
                      </span>
                    </td>
                    <td>
                      {c.status?.toUpperCase() === "REQUESTED" ? (
                        <button
                          type="button"
                          className="CollectionReport-verify-btn"
                          onClick={() => handleOpenVerifyModal(c)}
                        >
                          Verify
                        </button>
                      ) : (
                        <span className="CollectionReport-no-action">—</span>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>


         {/* 🔹 Verify Collection Modal */}
      {verifyModalOpen && selectedCollection && (
  <div
    className="cr-modal-overlay"
    onClick={() => !verifying && setVerifyModalOpen(false)}
  >
    <div
      className="cr-modal-content"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="cr-modal-header">
        <h3>Verify EMI Payment</h3>
        <button
          type="button"
          className="cr-modal-close"
          disabled={verifying}
          onClick={() => setVerifyModalOpen(false)}
        >
          ✕
        </button>
      </div>

      <form onSubmit={handleConfirmVerify}>
        <div className="cr-modal-body">
          {/* Loan & Customer Summary */}
          <div className="cr-detail-row">
            <span>Center Name:</span>
            <strong>{selectedCollection?.loanAccount?.centerName || "N/A"}</strong>
          </div>
          <div className="cr-detail-row">
            <span>Group Name:</span>
            <strong>{selectedCollection?.loanAccount?.groupName || "N/A"}</strong>
          </div>
          <div className="cr-detail-row">
            <span>Member Name:</span>
            <strong>{selectedCollection?.loanAccount?.memberName || "N/A"}</strong>
          </div>
          <div className="cr-detail-row">
            <span>Loan Number:</span>
            <strong>{selectedCollection?.loanAccount?.loanAccountNumber || "N/A"}</strong>
          </div>
          <div className="cr-detail-row">
            <span>EMI Number / ID:</span>
            <strong>
              {selectedCollection?.installmentNo ||
                selectedCollection?.id ||
                "N/A"}
            </strong>
          </div>
          <div className="cr-detail-row">
            <span>Amount to Pay:</span>
            <strong className="cr-amount-highlight">
              ₹
              {Number(selectedCollection?.emiAmount || 0).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </strong>
          </div>

          {/* Form Inputs for Payload */}
          <div className="cr-form-field">
            <label htmlFor="paymentModeSelect">Payment Mode *</label>
            <select
              id="paymentModeSelect"
              className="cr-input"
              value={paymentMode}
              disabled={verifying}
              onChange={(e) => setPaymentMode(e.target.value)}
            >
              <option value="CASH">Cash</option>
              <option value="UPI">UPI / QR</option>
              <option value="NET_BANKING">Net Banking / IMPS</option>
              <option value="CHEQUE">Cheque</option>
              <option value="CARD">Debit / Credit Card</option>
            </select>
          </div>

          <div className="cr-form-field">
            <label htmlFor="paymentDateInput">Payment Date *</label>
            <input
              id="paymentDateInput"
              type="date"
              className="cr-input"
              value={paymentDate}
              disabled={verifying}
              onChange={(e) => setPaymentDate(e.target.value)}
              required
            />
          </div>

          <div className="cr-form-field">
            <label htmlFor="paymentRemark">Remark</label>
            <input
              id="paymentRemark"
              type="text"
              className="cr-input"
              placeholder="Enter remarks (optional)"
              value={paymentRemark}
              disabled={verifying}
              onChange={(e) => setPaymentRemark(e.target.value)}
            />
          </div>
        </div>

        <div className="cr-modal-footer">
          <button
            type="button"
            className="cr-btn-cancel"
            disabled={verifying}
            onClick={() => setVerifyModalOpen(false)}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="cr-btn-confirm"
            disabled={verifying}
          >
            {verifying ? "Processing..." : "Confirm & Pay EMI"}
          </button>
        </div>
      </form>
    </div>
  </div>
)}

      {/* Pagination */}
      {!loading && rowsPerPage!=="All"  && (
        <div className="collection-report-pagination">
          <button
            className="collection-report-pagination-btn"
            onClick={handlePrev}
            disabled={currentPage === 1}
          >
            ⬅ Prev
          </button>
          <span className="collection-report-pagination-info">
            Page {currentPage} of {totalPages}
          </span>
          <button
            className="collection-report-pagination-btn"
            onClick={handleNext}
            disabled={currentPage === totalPages}
          >
            Next ➡
          </button>
        </div>
      )}
    </div>
  );
};

export default CollectionReportTest;
